import { File, FilesAndFolders, Folder, Id } from '@nextforce/api'
import { QueryClient } from '@tanstack/react-query'
import { produce } from 'immer'
import keys from './keys'

export function addRepositoryFileToCache(
  client: QueryClient,
  file: File,
  chatGroupId: Id
) {
  const chatGroupFolderKey = keys.chatGroupFolder(chatGroupId, file.folderId)
  const chatGroupFolderData =
    client.getQueryData<FilesAndFolders>(chatGroupFolderKey)
  if (chatGroupFolderData) {
    client.setQueryData<FilesAndFolders>(
      chatGroupFolderKey,
      produce(chatGroupFolderData, updatedData => {
        if (!updatedData.files) {
          updatedData.files = []
        }
        updatedData.files.push(file)
      })
    )
  }
}

export function addRepositoryFolderToCache(
  client: QueryClient,
  folder: Folder,
  chatGroupId: Id
) {
  const key = keys.chatGroupFolder(chatGroupId, folder.parentFolderId)
  const data = client.getQueryData<FilesAndFolders>(key)
  if (!data) {
    return
  }

  client.setQueryData<FilesAndFolders>(
    key,
    produce(data, updatedData => {
      if (!updatedData.folders) {
        updatedData.folders = []
      }
      updatedData.folders.push(folder)
    })
  )
}
